import { FC, useEffect } from 'react';
import { useFactory } from '@funtech-int/rival-react';

import { usePlayerAnalytics } from '@/scenarios/player/hooks/usePlayerAnalytics';
import { usePlayback } from '@/scenarios/player/hooks/usePlayback';
import { useTrackerData } from '@/scenarios/player/hooks/useTrackerData';

import { createPlayerTrackerManager } from '../../lib/playerTracker';
import { useOnError } from '../../hooks/useOnError';

interface PlayerTrackerProps {
    contentId: string;
}

export const PlayerTracker: FC<PlayerTrackerProps> = ({ contentId }) => {
    const playback = usePlayback();
    const trackerManager = useFactory(createPlayerTrackerManager);
    const handleError = useOnError({ contentId });

    const trackerData = useTrackerData();

    useEffect(() => {
        if (!playback.trackingData.filmoscopeInstance) {
            return;
        }

        trackerManager.init(playback.trackingData.filmoscopeInstance);
    }, [playback.trackingData.filmoscopeInstance, trackerManager]);

    useEffect(() => {
        trackerManager.setTrackings(trackerData, contentId);
    }, [trackerManager, trackerData, contentId]);

    usePlayerAnalytics({
        filmoscopeInstance: playback.trackingData.filmoscopeInstance,
        contentId,
        psid: playback.psid,
        manifestUrl: playback.trackingData.manifestUrl,
    });

    useEffect(() => {
        const unsubError = playback.listen('error', (error) => {
            handleError(error, playback.vsid.value);
        });

        return unsubError;
    }, [handleError, playback]);

    return null;
};
